import { symbol } from 'd3-shape';

export function renderScatterSeries(parentElem, graph, panel, series, xScale, yScale) {

	const symbolGenerator = symbol().size(value => value === null ? 0 : 16);

	const points = parentElem.append('g')
		.attr('class', `hw_panel_graph_series hw_panel_graph_scatter_series hw_panel_graph_series_${series.config.name}`)
		.selectAll(`path.${series.config.name}`)
		.data(graph.config.data)
		.enter()
		.append('path')
		.attr('transform', d => {
			const x = xScale(graph.config.xAxis.config.dataAccessor(d));
			const y = yScale(series.config.dataAccessor(d));
			return `translate(${x},${y})`;
		})
		.attr('d', d => {
			const value = series.config.dataAccessor(d);
			return symbolGenerator(value);
		});

	if (series.config.color !== null) {
		points.style('fill', series.config.color);
	}

}



// WEBPACK FOOTER //
// ./utils/panelgraph/functions/render-series-scatter.js